/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Ip_Item_1Inputs */

const es_tyc_ip_item_1 = /** @type {(inputs: Tyc_Ip_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los derechos sobre el Servicio, incluyendo software, documentacion, interfaces y la marca "Nexata", son propiedad exclusiva de Nexata o sus licenciantes.`)
};

const en_tyc_ip_item_1 = /** @type {(inputs: Tyc_Ip_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All rights to the Service, including software, documentation, interfaces, and the "Nexata" brand, are the exclusive property of Nexata or its licensors.`)
};

/**
* | output |
* | --- |
* | "All rights to the Service, including software, documentation, interfaces, and the \"Nexata\" brand, are the exclusive property of Nexata or its licensors." |
*
* @param {Tyc_Ip_Item_1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_ip_item_1 = /** @type {((inputs?: Tyc_Ip_Item_1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Ip_Item_1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_ip_item_1(inputs)
	return en_tyc_ip_item_1(inputs)
});
export { tyc_ip_item_1 as "tyc.ip.item_1" }